// Sidebar entries owned by the Asset module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { assetPaths } from './paths'

export const assetNav = {
    list: {
        title: 'asset:sidebar_title',
        path: assetPaths.assetsList,
        ignorePermission: true,
    },
} satisfies Record<string, SidebarType>
